import { Avatar, Grid, makeStyles, Typography } from "@material-ui/core";
import moment from "moment";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 20,
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  textContainer: {
    paddingLeft: 48,
  },
  typography: {
    padding: 6,
  },
  viewMore: {
    textAlign: "center",
    margin: 24,
  },
}));

function CoinHeader({ coinData, loading }) {
  const classes = useStyles();
  return (
    <Grid
      xs={12}
      container
      direction="row"
      className={classes.root}
      alignItems="center"
    >
      {loading ? (
        <Skeleton animation="wave" variant="circle" width={90} height={90} />
      ) : (
        <Avatar
          className={classes.large}
          alt="Coin Image"
          src={`https://static.coincap.io/assets/icons/${coinData.symbol
            .toString()
            .toLowerCase()}@2x.png`}
        />
      )}

      <Grid className={classes.textContainer} xs={6}>
        {loading ? (
          <Skeleton
            animation="wave"
            height={30}
            width="30%"
            style={{ marginBottom: 6 }}
          />
        ) : (
          <Typography className={classes.typography} variant="h6">
            {coinData.name}
          </Typography>
        )}

        {loading ? (
          <Skeleton
            animation="wave"
            height={30}
            width="30%"
            style={{ marginBottom: 6 }}
          />
        ) : (
          <Typography className={classes.typography} variant="subtitle2">
            {moment(coinData.timestamp).format("DD MMMM YYYY")}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

export default CoinHeader;
